export default __webpack_public_path__ + "static/media/wave_gray.9c7a024f.svg";